import React from 'react';

const STEPS = [
  { key: 'kyc', label: 'KYC Verified', weight: 33.33 },
  { key: 'deposit', label: 'First Deposit', weight: 33.33 },
  { key: 'isLiveAccount', label: 'Live Account Ready', weight: 33.34 },
];

const calcProgress = (progress) => {
  if (!progress) return 0;
  return STEPS.reduce((total, step) => (
    progress[step.key] ? total + step.weight : total
  ), 0);
};

const UserProgressBar = ({ progress }) => {
  if (!progress) return null;

  const percent = Math.min(100, Number(calcProgress(progress).toFixed(2)));

  // Completed steps first, incomplete steps last — keeps the bar fill contiguous
  const orderedSteps = [...STEPS].sort((a, b) => {
    const aDone = progress[a.key] ? 1 : 0;
    const bDone = progress[b.key] ? 1 : 0;
    return bDone - aDone;
  });

  return (
    <div className="border-2 border-light rounded-[10px] p-5 mt-6">
      <div className="flex items-center justify-between gap-3 mb-3">
        <h2 className="text-lg font-semibold">Complete Your Profile</h2>
        <span className="primary font-semibold text-sm">{percent}%</span>
      </div>

      <div className="w-full h-2.5 bg-[#E9ECEF] rounded-full overflow-hidden">
        <div
          className="h-full bg-primary rounded-full transition-all duration-500"
          style={{ width: `${percent}%` }}
        />
      </div>

      <div className="grid grid-cols-3 gap-2 mt-4">
        {orderedSteps.map((step) => {
          const done = !!progress[step.key];
          return (
            <div key={step.key} className="flex flex-col items-center text-center gap-1">
              <span
                className={`flex items-center justify-center w-6 h-6 rounded-full text-xs font-semibold ${
                  done ? 'bg-primary text-white' : 'bg-[#E9ECEF] text-gray-500'
                }`}
              >
                {done ? '✓' : ''}
              </span>
              <span className={`text-xs sm:text-sm ${done ? 'primary font-medium' : 'text-gray-500'}`}>
                {step.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UserProgressBar;
